// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3pQiP","wide":"styles-module--wide--1MNfX"};